import React from "react";
import MDBox from "./MDBox";
import MDTypography from "./MDTypography";

const TotalsView = ({ title, amount, variant }) => {
  return (
    <MDBox
      width="fit-content"
      display="flex"
      alignItems="center"
      lineHeight={1}
      style={{
        cursor: "pointer",
        backgroundColor: "#000000c2",
        padding: "3px 10px",
        borderRadius: "10px",
      }}
    >
      <MDTypography fontSize={15} color="white" mr={2}>
        {`${title}: `}
      </MDTypography>
      <MDTypography fontSize={15} fontWeight={"bold"} color={variant}>
        {amount}
      </MDTypography>
    </MDBox>
  );
};

export default TotalsView;
